import React, { useState, useContext, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
import { urls } from "../URLs";
import crypto from "crypto";
import { ContextMenuTrigger } from "react-contextmenu";
import { generateCaptcha } from "../utils/GenerateCaptcha";
import {
  generateHashKey2,
  getDiviceInfo,
  getLatLong,
  getMacAddress,
  getMyIPAddress,
  onlyAlpha,
  onlyAlphaNumeric,
  onlyNumeric,
  uniqueID2,
} from "../utils/utilFuctions";
import {
  BASE_URL_API,
  BASE_URL_API_TRANXT,
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../utils/Constants";
import Error404 from "../error-pages/Error404";
import FoodIcon from "../../assets/svg/food.svg";
import PaymentIcon from "../../assets/svg/payment.svg";
import TravelIcon from "../../assets/svg/travel.svg";
import CompanyLogo from "../../assets/images/Bumppy_Payment_logo.svg";
import MediaLogo from "../../assets/svg/media.svg";
import { auth } from "../utils/firebase/firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import swal from "sweetalert";
import banner1 from "../../assets/images/bumppyloginpageimgone.png";
import banner2 from "../../assets/images/bumppyloginpageimgtwo.png";
import banner3 from "../../assets/images/bumppyloginpageimgthree.png";
import BumppyQr from "../../assets/images/bumppyqr.png";
import LocationGuard from "../LocationGuard";

const transformPinResponse = (apiResponse) => {
  if (!apiResponse || !apiResponse.data) {
    return null;
  }

  const { data } = apiResponse;

  return {
    id: data.id || "Y",
    Id: data.id || "Y",
    referId: data.us_code || "",
    ReferId: data.us_code || "",
    mobile: data.us_loginid || "",
    email: data.us_email || "",
    isUserActive: data.isUserActive ? "Y" : "N",
    walletBalance: parseFloat(data.balance) || 0,
    userType: data.us_type || "",
    UserType: data.us_type || "",
    userTypeDesc: "",
    result: apiResponse.msg || "Login Success",
    pk_user_id: data.pk_user_id?.toString() || "",
    f_onboard_status: data.fingpay_onboard_status || "",
    f_ekyc_status: data.fingpay_ekyc_status || "",
    bumppy_onboard_status: data.bumppy_onboarding_status || "",
    bumppy_ekyc_status: data.bumppy_ekyc_status || "",
    bankit_onboard_status: data.bankit_onboarding_status || "",
    bankit_ekyc_status: data.bankit_ekyc_status || "",
    // Additional fields from original response
    shopname: data.shopname || "",
    us_company: data.us_company || "",
    distributor: data.distributor || "",
    dist_name: data.dist_name || "",
    dist_number: data.dist_number || "",
    isPassChange: data.isPassChange || false,
  };
};

export default function Login5() {
  const [signinDisable, setSigninDisable] = useState(false);
  const [networkInfo, setNetworkInfo] = useState({
    speedType: "unknown",
    connectionType: "unknown",
  });
  const [isLocked, setIsLocked] = useState(false);
  const history = useHistory();
  const { login: loginUrl } = urls;
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState("");
  const [activeTab, setActiveTab] = useState("password");
  const [contry, setCountry] = useState("+91");
  const [error, setError] = useState("");
  const [textOtp, setTextOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [captcha, setCaptcha] = useState(false);
  const [storedUser, setStoredUser] = useState(null);
  const [resendOtpEnable, setResendOtpEnable] = useState(false);
  const [passShow, setPassShow] = useState(false);
  const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
  const [seconds, setSeconds] = useState(60);
  const [formErrors2, setFormErrors2] = useState({
    otp: "",
  });

  const [loading, setLoading] = useState(false);

  const { setUserInfo, user, setTransactionLoaderState } =
    useContext(GlobalContext);
  const [formErrors, setFormErrors] = useState({
    username: "",
    password: "",
    pin: "", // NEW: PIN validation
  });



  

  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {},
          "expired-callback": () => {},
        },
        auth
      );
      onSignup();
    }
  }

  function onSignup() {
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;

    console.log(appVerifier);

    const formatPh = contry + userName;
    console.log(formatPh);

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        toast.success("OTP sended successfully!");
        setOtpSent(true);
        setResendOtpEnable(false);
        setSeconds(60);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(textOtp)
      .then(async (res) => {
        setUserInfo(storedUser);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const createHash = () => {
    return crypto.createHash("md5").update(password).digest("hex");
  };

  const loadCaptchaEnginge = (length) => {
    setGeneratedCaptcha(generateCaptcha());
  };

  // NEW: Validate PIN login
  const validatePin = async () => {
    let errors = {};
    if (userName.length < 8) {
      errors.username = "please enter valid mobile number";
    }
    if (pin.length !== 4) {
      errors.pin = "please enter 4 digit PIN";
    }

    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      await loginWithPin();
    } else {
      setSigninDisable(false);
      setFormErrors(errors);
    }
  };

  // NEW: PIN Login API
  const loginWithPin = async () => {
    try {
      setTransactionLoaderState(true);
      setSigninDisable(false);

      let coords = await getLatLong();
      const getDeviceData = await getMyIPAddress();

      const raw = JSON.stringify({
        mobile: userName,
        pin: pin,
        app_version: "4.0.7",
        browser: getDeviceData.browser_name || "Nothing",
        browser_name: getDeviceData.browser_name || "APP",
        browser_version: getDeviceData.browser_version || 35,
        device_id: "web_" + Date.now(),
        device_model: getDeviceData.platform || "Web",
        device_type: "WEB",
        ip_address: getDeviceData.ip_address,
        latitude: coords[0] || "0",
        longitude: coords[1] || "0",
        mac_address: getDeviceData.mac_address,
        network_operator: networkInfo.speedType,
        network_type: networkInfo.connectionType,
        opagename: getDeviceData.opagename,
        os_version: getDeviceData.os_version,
        password: "NA",
        platform: "WEB",
        user_agent: getDeviceData.user_agent,
        user_name: "NA",
        vendor: getDeviceData.vendor,
      });

      var myHeaders = new Headers();
      myHeaders.append("ADMIN-ID", "3");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4="
      );

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/Payment/user/verifypin`,
        requestOptions
      );
      const data = await res.json();

      console.log("Original PIN API Response:", data);

      // Check if login was successful
      if (data.status === "0" && data.data?.id === "Y") {
        // Transform the response to match session format
        const sessionUser = transformPinResponse(data);

        console.log("Transformed Session User:", sessionUser);

        // Set user info with transformed data
        setUserInfo(sessionUser);
        setTransactionLoaderState(false);
        toast.success("Login successful!");
      } else {
        setTransactionLoaderState(false);
        const errorMessage =
          data.msg || data.message || "Invalid PIN. Please try again.";
        setError(errorMessage);

        // Check if account is locked
        if (
          errorMessage.toLowerCase().includes("locked") ||
          errorMessage.toLowerCase().includes("attempts")
        ) {
          setIsLocked(true);
        }
        swal("Failed", errorMessage, "error");
      }
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    }
  };

  const validate = async (callback) => {
    let errors = {};
    if (userName.length < 8) {
      errors.username = "please enter valid mobile number";
    }
    if (password.length < 4) {
      errors.password = "please enter valid password";
    }

    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      const userExist = await login();
      if (!userExist) {
        setSigninDisable(false);
        return;
      }
      console.log(contry);
      if (contry == "+91") {
        loginWithOtp((user) => {
          setUserInfo(user);
        });
      } else {
        login3(true, onSignup);
      }
    } else {
      setSigninDisable(false);
      setFormErrors(errors);
    }
  };

  const validate2 = () => {
    let errors = {};
    if (textOtp.length < 6) {
      errors.otp = "please enter valid OTP";
    }
    setFormErrors2(errors);
    if (Object.keys(errors).length === 0) {
      if (contry == "+91") {
        login2("", (user) => {
          setUserInfo(user);
        });
      } else {
        onOTPVerify();
      }
    } else {
      setFormErrors2(errors);
    }
  };

  const login2 = async (userType, callback) => {
    const raw = JSON.stringify({
      otp: textOtp,
      user_name: userName,
      password: password,
    });
    const hash_key = await generateHashKey2(userName);
    var myHeaders = new Headers();
    myHeaders.append("HASH_KEY", hash_key);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setTransactionLoaderState(true);
      const hash = createHash();
      console.log({ hash, userName, captcha });
      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/User/v1.0/agentLoginValidateOtp`,
        requestOptions
      );
      const data = await res.json();
      const user = data;
      if (user.id === "Y") {
        const sessionUser = {
          ...user,
          Id: user.id,
          UserType: user.userType,
          ReferId: user.referId,
        };
        setUserInfo(sessionUser);
        setTransactionLoaderState(false);
      } else {
        setTransactionLoaderState(false);
        if (user.Result) {
          setIsLocked(true);
          setError(user.Result);
        } else {
          swal(" Failed", data.result, "error");
        }
        loadCaptchaEnginge(4);
      }
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  // const login3 = async (flag, callback) => {
  //   const raw = "";
  //   const hash_key = await generateHashKey2(userName);
  //   var myHeaders = new Headers();
  //   myHeaders.append("HASH_KEY", hash_key);
  //   myHeaders.append("Content-Type", "application/json");
  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   try {
  //     setTransactionLoaderState(true);
  //     setSigninDisable(false);
  //     const hash = createHash();

  //     const res = await fetch(
  //       `${BASE_URL_API_TRANXT}/apiget.aspx?method=login2&mobile=${userName}&password=${hash}`,
  //       requestOptions
  //     );
  //     const data = await res.json();
  //     const user = data;
  //     if (user.Id === "Y") {
  //       if (flag) {
  //         setStoredUser(user);
  //         callback();
  //       } else {
  //         setUserInfo(user);
  //       }
  //       setTransactionLoaderState(false);
  //     } else {
  //       setTransactionLoaderState(false);
  //       swal(" Failed", data.result, "error");
  //       loadCaptchaEnginge(4);
  //     }
  //   } catch (error) {
  //     setTransactionLoaderState(false);
  //     console.log("error", error);
  //   }
  // };

  const login3 = async (flag, callback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4="
    );
    const hash = createHash();
    const raw = JSON.stringify({
      loginID: userName,
      password: hash,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setTransactionLoaderState(true);
      setSigninDisable(false);
       const res = await fetch(
        // `${BASE_URL_API_TRANXT}/apiget.aspx?method=login2&mobile=${userName}&password=${hash}`,
        `${BASE_URL_API}/api/Apitranxt/login2`,
        requestOptions
      );
      const data = await res.json();
      const user = data;
      if (user.id === "Y") {
        if (flag) {
          setStoredUser(user);
          callback();
        } else {
          setUserInfo(user);
        }
        setTransactionLoaderState(false);
      } else {
        setTransactionLoaderState(false);
        swal(" Failed", data.result, "error");
        loadCaptchaEnginge(4);
      }
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const login = async () => {
    setTransactionLoaderState(true);
    const raw = JSON.stringify({
      mobile: userName,
      capatcha: captcha,
    });
    const hash_key = await generateHashKey2(userName);
    var myHeaders = new Headers();
    myHeaders.append("HASH_KEY", hash_key);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/User/v2.0/agentLoginMobile`,
        requestOptions
      );
      const raw = await res.text();
      const data = JSON.parse(raw);
      console.log(data);
      if (data.responseCode == "00") {
        // const sid = "SESS" + Date.now();
        // localStorage.setItem("sessionid", sid);

        // const userIdToRegister = user.referId || sessionUser.ReferId;
        // console.log("Registering session for:", userIdToRegister);
        // await retailerSession(userIdToRegister, sid);
        // retailerSession();
        return true;
      } else {
        setIsLocked(true);
        setError(data.responseMessage);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      setError("Invalid Credentials");
      loadCaptchaEnginge(4);
      console.log("error", error);
    }
  };

  const loginWithOtp = async (callback) => {
    try {
      setTransactionLoaderState(true);
      setSigninDisable(false);
      setOtpSent(false);
      let coords = await getLatLong();
      const getDeviceData = await getMyIPAddress();

      var raw = JSON.stringify({
        opagename: getDeviceData.opagename,
        os_version: getDeviceData.os_version,
        browser_name: getDeviceData.opagename,
        browser_version: getDeviceData.browser_version,
        user_agent: getDeviceData.user_agent,
        app_version: getDeviceData.app_version,
        platform: getDeviceData.platform,
        vendor: getDeviceData.vendor,
        ip_address: getDeviceData.ip_address,
        mac_address: getDeviceData.mac_address,
        user_name: userName,
        password: password,
        device_type: "WEB",
        latitude: coords[0],
        longitude: coords[1],
        network_type: networkInfo.connectionType,
        network_speed: networkInfo.speedType,
        network_operator: networkInfo.speedType,
      });

      const hash_key = await generateHashKey2(userName);
      var myHeaders = new Headers();
      myHeaders.append("HASH_KEY", hash_key);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/User/v1.0/agentLoginSendOtp`,
        requestOptions
      );
      const data = await res.json();
      if (data.id == "Y") {
        retailerSession();
        if (data.referId != "") {
          console.log(data);

          const sessionUser = {
            ...data,
            Id: data.id,
            UserType: data.userType,
            ReferId: data.referId,
          };
          
          setUserInfo(sessionUser);
        } else {
          setOtpSent(true);
          setResendOtpEnable(false);
          setSeconds(60);
        }
      } else {
        if (
          data.result.toString().toLowerCase().includes("attempts left") ||
          data.result.toString().toLowerCase().includes("locked")
        ) {
          setError(data.result);
          setIsLocked(true);
        } else if (data.result == "Your Account Has been Locked") {
          setError("Your Account Has been Locked");
        } else {
          login3(false);
        }
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const retailerSession = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userid: user.ReferId,
        sessionid: "123456",
        device: "WEB"
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      const res = await fetch(`https://api.bumppypay.com/api/Apitranxt/add_session`,
        requestOptions
      );

      const data = await res.json()
      console.log('add session', data)

      console.log("Session added successfully");
    } catch (error) {
      console.log("Session add error:", error);
    }
  };
  const goToForgetPassword = () => history.push("/forget-password");

  const showPasswordClick = () => {
    setPassShow(!passShow);
  };

  // NEW: Handle PIN input (only numbers, max 4 digits)
  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length <= 4) {
      setPin(value);
      setError("");
    }
  };

  useEffect(() => {
    if (seconds === 0) {
      setResendOtpEnable(true);
    } else {
      const intervalId = setInterval(() => {
        setSeconds(seconds - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [seconds]);

  useEffect(() => {
    if (signinDisable) {
      if (activeTab === "pin") {
        validatePin();
      } else {
        validate();
      }
    }
  }, [signinDisable]);

  useEffect(() => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (!connection) return;

    const updateNetworkInfo = () => {
      setNetworkInfo({
        speedType: connection.effectiveType || "unknown",
        connectionType: connection.type || "unknown",
      });
    };

    updateNetworkInfo();
    connection.addEventListener("change", updateNetworkInfo);

    return () => {
      connection.removeEventListener("change", updateNetworkInfo);
    };
  }, []);

  const resendOtpText = "Time Remaining: ";

  const minutes = Math.floor(seconds / 60);
  const formattedSeconds = String(seconds % 60).padStart(2, "0");
  const formattedTime = `${resendOtpText}${minutes}:${formattedSeconds}`;

  var Cookies = document.cookie.split(";");

  console.log(Cookies);
  for (var i = 0; i < Cookies.length; i++) {
    document.cookie = Cookies[i] + "=; expires=" + new Date(0).toUTCString();
  }

  return (
    <GlobalContext.Consumer>
      

     
      {(context) =>
        context.user == null || context.user.Id !== "Y" ? (
          <>
          <LocationGuard>
            <style>
              {`
              @media (max-width: 768px) {
                .login-root {
                  flex-direction: column !important;
                }
                .left-panel {
                  display: none !important;
                }
                .right-panel {
                  width: 100% !important;
                  padding: 24px !important;
                }
              }
  
              @media (min-width: 769px) and (max-width: 1024px) {
                .left-panel {
                  width: 45% !important;
                }
                .right-panel {
                  width: 55% !important;
                  padding: 32px !important;
                }
              }
            `}
            </style>

            <div id="secure-ui"
              className="login-root"
              style={{
                minHeight: "100vh",
                display: "flex",
                background: "linear-gradient(90deg, #2F80ED 0%, #1C5FD4 100%)",
                overflow: "hidden",
              }}
            >
              <Toaster toastOptions={{ duration: 4000 }} />
              <div id="recaptcha-container"></div>
              <div
                className="left-panel"
                style={{
                  width: "40%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "0px",
                }}
              >
                <div
                  style={{
                    width: "520px",
                    height: "640px",
                    background: "#2e77ff",
                    borderRadius: "12px",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <style>
                    {`
                    @keyframes slideCarousel {
                      0% { transform: translateX(120%); opacity: 0; visibility: hidden; }
                      10% { transform: translateX(0); opacity: 1; visibility: visible; }
                      30% { transform: translateX(0); opacity: 1; visibility: visible; }
                      40% { transform: translateX(-120%); opacity: 0; visibility: hidden; }
                      100% { transform: translateX(-120%); opacity: 0; visibility: hidden; }
                    }
                    .phone-slide {
                      position: absolute;
                      inset: 0;
                      border-radius: 32px;
                      background-size: cover;
                      background-repeat: no-repeat;
                      background-position: center;
                      animation: slideCarousel 12s infinite ease-in-out;
                    }
                    .slide-1 { animation-delay: 0s; }
                    .slide-2 { animation-delay: 4s; }
                    .slide-3 { animation-delay: 8s; }
                  `}
                  </style>

                  <div
                    style={{
                      width: "460px",
                      height: "460px",
                      background: "#4988fe",
                      borderRadius: "50%",
                      position: "absolute",
                      top: "40%",
                      left: "45%",
                      transform: "translate(-45%, -45%)",
                    }}
                  />

                  <div
                    style={{
                      width: "260px",
                      height: "520px",
                      marginTop: "30px",
                      position: "relative",
                    }}
                  >
                    <div
                      className="phone-slide slide-1"
                      style={{ backgroundImage: `url(${banner1})` }}
                    />
                    <div
                      className="phone-slide slide-2"
                      style={{ backgroundImage: `url(${banner2})` }}
                    />
                    <div
                      className="phone-slide slide-3"
                      style={{ backgroundImage: `url(${banner3})` }}
                    />
                  </div>

                  <div
                    style={{
                      width: "100%",
                      background: "#eaf1ff",
                      padding: "22px 24px",
                      position: "absolute",
                      bottom: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ maxWidth: "70%" }}>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: 600,
                          fontSize: "20px",
                          color: "#0b3ea8",
                        }}
                      >
                        Scan the QR to download the app
                      </p>
                      <p
                        style={{
                          marginTop: "6px",
                          fontSize: "18px",
                          color: "#355fae",
                        }}
                      >
                        Effortlessly manage your transactions & settlements
                      </p>
                    </div>

                    <img
                      src={BumppyQr}
                      style={{
                        width: "90px",
                        height: "90px",
                        background: "#fff",
                        padding: "6px",
                        borderRadius: "6px",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                className="right-panel"
                style={{
                  width: "60%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "48px",
                }}
              >
                <div style={{ width: "100%", maxWidth: "380px" }}>
                  <div className="text-center mb-3">
                    <img src={CompanyLogo} style={{ height: "4rem" }} />
                  </div>

                  <h5 className="text-center font-weight-bold mb-3">
                    Sign in to continue
                  </h5>
                  <div
                    className="d-flex justify-content-center mb-4"
                    style={{ borderBottom: "1px solid #E0E0E0" }}
                  >
                    <div
                      onClick={() => {
                        setActiveTab("password");
                        setError("");
                        setFormErrors({});
                        setOtpSent(false);
                      }}
                      style={{
                        width: "50%",
                        textAlign: "center",
                        padding: "12px 0",
                        cursor: "pointer",
                        fontWeight: activeTab === "password" ? "500" : "400",
                        color: activeTab === "password" ? "#111" : "#9E9E9E",
                        borderBottom:
                          activeTab === "password"
                            ? "2px solid #2F80ED"
                            : "none",
                      }}
                    >
                      Login with Password
                    </div>

                    <div
                      onClick={() => {
                        setActiveTab("pin");
                        setError("");
                        setFormErrors({});
                        setOtpSent(false);
                      }}
                      style={{
                        width: "50%",
                        textAlign: "center",
                        padding: "12px 0",
                        cursor: "pointer",
                        fontWeight: activeTab === "pin" ? "500" : "400",
                        color: activeTab === "pin" ? "#111" : "#9E9E9E",
                        borderBottom:
                          activeTab === "pin" ? "2px solid #2F80ED" : "none",
                      }}
                    >
                      Login With PIN
                    </div>
                  </div>

                  <form style={{ maxWidth: "360px", margin: "0 auto" }}>
                    <div className="form-group mb-4">
                      <label style={{ fontSize: "12px", color: "#555" }}>
                        Mobile number
                      </label>

                      <div className="d-flex align-items-center border-bottom">
                        <select
                          className="border-0 bg-transparent pr-2"
                          style={{ fontSize: "14px", outline: "none" }}
                          onChange={(e) => setCountry(e.target.value)}
                        >
                          <option>+91</option>
                          <option>+1</option>
                        </select>

                        <input
                          className="form-control border-0 shadow-none"
                          placeholder="Enter Mobile Number"
                          style={{ fontSize: "14px" }}
                          value={userName}
                          onChange={(e) => {
                            setError("");
                            setUserName(e.target.value);
                          }}
                        />
                      </div>

                      <small className="text-danger">
                        {formErrors.username}
                      </small>
                    </div>

                    {activeTab === "password" ? (
                      <div className="form-group mb-3">
                        <label style={{ fontSize: "12px", color: "#555" }}>
                          Password
                        </label>

                        <div className="d-flex align-items-center border-bottom">
                          <input
                            type={passShow ? "text" : "password"}
                            className="form-control border-0 shadow-none"
                            placeholder="Enter password"
                            style={{ fontSize: "14px" }}
                            value={password}
                            onChange={(e) => {
                              setError("");
                              setPassword(e.target.value);
                            }}
                          />

                          <span
                            style={{ cursor: "pointer" }}
                            onClick={showPasswordClick}
                          >
                            <i
                              className={`mdi ${
                                passShow ? "mdi-eye" : "mdi-eye-off"
                              }`}
                            />
                          </span>
                        </div>

                        <small className="text-danger">
                          {formErrors.password}
                        </small>
                      </div>
                    ) : (
                      <div className="form-group mb-3">
                        <label style={{ fontSize: "12px", color: "#555" }}>
                          4-Digit PIN
                        </label>

                        <div className="d-flex align-items-center border-bottom">
                          <input
                            className="form-control border-0 shadow-none"
                            placeholder="Enter PIN"
                            maxLength={4}
                            value={pin}
                            onChange={handlePinChange}
                            style={{ fontSize: "14px" }}
                          />
                        </div>

                        <small className="text-danger">{formErrors.pin}</small>
                      </div>
                    )}

                    {otpSent && activeTab === "password" && (
                      <div>
                        <div className="form-group mb-3">
                          <label style={{ fontSize: "12px", color: "#555" }}>
                            Enter OTP
                          </label>

                          <div className="d-flex align-items-center border-bottom">
                            <input
                              className="form-control border-0 shadow-none"
                              placeholder="Enter OTP"
                              value={textOtp}
                              onChange={(e) => setTextOtp(e.target.value)}
                              style={{ fontSize: "14px" }}
                            />
                          </div>

                          <small className="text-danger">
                            {formErrors2?.otp}
                          </small>
                        </div>
                        <div
                          className="d-flex justify-content-between align-items-center mb-3"
                          style={{ fontSize: "12px" }}
                        >
                          <span style={{ color: "#777" }}>
                            Didn’t receive the OTP?
                          </span>

                          <span
                            style={{
                              color: "#2F80ED",
                              cursor: "pointer",
                              fontWeight: 500,
                            }}
                            onClick={() => {
                              validate();
                            }}
                          >
                            Resend OTP
                          </span>
                        </div>
                      </div>
                    )}
                    {activeTab === "password" && (
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label
                            className="form-check-label text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            Keep me signed in
                          </label>
                        </div>

                        <a
                          href="#"
                          style={{ fontSize: "12px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            goToForgetPassword();
                          }}
                        >
                          Forgot password?
                        </a>
                      </div>
                    )}

                    {error && <Invalid text={error} />}

                    <button
                      type="button"
                      disabled={signinDisable}
                      className="btn btn-block mb-3"
                      style={{
                        border: "1.5px solid #2F80ED",
                        color: "#2F80ED",
                        background: "white",
                        borderRadius: "8px",
                        padding: "10px",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        if (otpSent && activeTab === "password") {
                          validate2();
                        } else {
                          setSigninDisable(true);
                          // loginHandler();
                        }
                      }}
                    >
                      Sign in
                    </button>

                    {isLocked && (
                      <Link
                        to="/activate-user"
                        className="btn btn-block text-white"
                        style={{ background: "#85AFD4" }}
                      >
                        Activate Account
                      </Link>
                    )}
                  </form>
                  <p
                    className="text-center mt-4"
                    style={{ fontSize: "11px", color: "#777" }}
                  >
                    Invisible reCAPTCHA by Google ·{" "}
                    <a href="/terms-and-conditions">Privacy Policy</a> and{" "}
                    <a href="/terms-and-conditions">Terms of Use</a>
                  </p>

                  <p
                    className="text-center text-muted"
                    style={{ fontSize: "10px" }}
                  >
                    © 2023 Bumppy. All rights reserved.
                  </p>
                </div>
              </div>
            </div>
            </LocationGuard>
          </>
        ) : context.user && context.user.UserType === "2" ? (
          <Redirect to="/retailer/dashboard" />
        ) : context.user && context.user.UserType === "3" ? (
          <Redirect to="/distributor/dashboard" />
        ) : context.user && context.user.UserType === "4" ? (
          <Redirect to="/master-distributor/dashboard" />
        ) : context.user && context.user.UserType === "1" ? (
          <Redirect to="/user/dashboard" />
        ) : (
          <Error404 />
        )
      } 
      
    
    </GlobalContext.Consumer>
  );
}

const Invalid = ({ text }) => {
  console.log("hiii");
  return (
    <div className="card-inverse-danger">
      <ContextMenuTrigger id="actionContextMenu">
        <div className="card-body" style={{ padding: "10px" }}>
          <p className="card-text">{text}</p>
        </div>
      </ContextMenuTrigger>
    </div>
  );
};
